import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import StorageService from '../services/storageService';
import createSelectors from './createSelectors';
import resetter from './resetter';
import { createUserSlice, UserSlice, UserState } from './slices/user.slice';
import { STORE_NAME } from './store.utils';
import { createInterviewInviteSlice, InterviewInviteSlice } from './slices/interviewInvite.slice';

type HasHydrated = {
  _hasHydrated: boolean;
  setHasHydrated: (value: boolean) => void;
};

export type Store = UserSlice & InterviewInviteSlice & HasHydrated;

export type Mutators = [['zustand/persist', UserState]];

export type StoreSet = (
  partial: Store | Partial<Store> | ((state: Store) => Store | Partial<Store>),
  replace?: boolean | undefined
) => void;

const useStoreBase = create<Store>()(
  persist(
    (...args) => ({
      _hasHydrated: false,
      setHasHydrated: (state: boolean) => {
        const set = args[0];
        set({
          _hasHydrated: state,
        });
      },
      ...createUserSlice(...args),
      ...createInterviewInviteSlice(...args),
    }),
    {
      name: STORE_NAME,
      storage: createJSONStorage(() => StorageService),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
      partialize: (state) => ({
        user: state.user,
      }),
    }
  )
);

const useMainStore = createSelectors(useStoreBase);

export const resetStore = () => {
  resetter.resetAll();
};

export default useMainStore;
